module.exports = __webpack_public_path__ + "img/3-1.8dfc7764.png";